<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    ViewRecord () {
        this.$router.push("/stock/" + this.params.data.idproduct).catch(() => {})
    }
  }
}
</script>
